import { TimeFrameTypes } from "@app/models/enums";

export interface AdminDashboardSummaryPostDto {
  startDate?: string;
  endDate?: string;
  period: TimeFrameTypes;
  timeZoneOffset?: number;
}

export interface AdminReportSummaryItemDto {
  totalCount: number;
  name: string;
}

export interface AdminReportSummaryDto {
  total: number;
  summary: AdminReportSummaryItemDto[];
}

export interface AdminDashboardSummaryDto {
  topAccountsActivity: AdminReportSummaryDto;
  topPartnersActivity: AdminReportSummaryDto;
  topLocationActivities: AdminReportSummaryDto;
  customLinks: AdminReportSummaryDto;
}
